import { render, staticRenderFns } from "./AuthorBar.vue?vue&type=template&id=46c82d30&scoped=true"
import script from "./AuthorBar.vue?vue&type=script&lang=js"
export * from "./AuthorBar.vue?vue&type=script&lang=js"
import style0 from "./AuthorBar.vue?vue&type=style&index=0&id=46c82d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c82d30",
  null
  
)

export default component.exports